import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseDialogOptions } from '../dialogoptions';
// #region Custom Classes
var BaseSelectBoxNoteDialogOptions = /** @class */ (function (_super) {
    tslib_1.__extends(BaseSelectBoxNoteDialogOptions, _super);
    function BaseSelectBoxNoteDialogOptions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BaseSelectBoxNoteDialogOptions;
}(BaseDialogOptions));
export { BaseSelectBoxNoteDialogOptions };
var BaseSelectBoxNoteSelectionOption = /** @class */ (function () {
    function BaseSelectBoxNoteSelectionOption() {
    }
    return BaseSelectBoxNoteSelectionOption;
}());
export { BaseSelectBoxNoteSelectionOption };
var BaseSelectBoxNoteResult = /** @class */ (function () {
    function BaseSelectBoxNoteResult() {
    }
    return BaseSelectBoxNoteResult;
}());
export { BaseSelectBoxNoteResult };
// #endregion
var SelectBoxNoteDialogComponent = /** @class */ (function () {
    function SelectBoxNoteDialogComponent(dialogRef, data) {
        this.dialogRef = dialogRef;
        this.data = data;
        this.title = data.TitleText || 'Information';
        this.message = data.MessageText || '';
        this.oktext = data.OKText || 'OK';
        this.canceltext = data.CancelText || 'Cancel';
        this.options = data.Options || [];
        this.note = data.Note || '';
        this.noteprefix = data.NotePrefix || '';
        this.current = data.Current;
        this.requiresNote = data.RequiresNote != null ? data.RequiresNote : true;
        this.selection = data.Current;
        this.showIcon = data.ShowIcon;
    }
    SelectBoxNoteDialogComponent.prototype.ngOnInit = function () { };
    SelectBoxNoteDialogComponent.prototype.CancelHandler = function () {
        this.dialogRef.close(null);
    };
    SelectBoxNoteDialogComponent.prototype.OKHandler = function () {
        this.dialogRef.close({
            Selection: this.selection,
            Note: this.note,
        });
    };
    return SelectBoxNoteDialogComponent;
}());
export { SelectBoxNoteDialogComponent };
